import { RouteConstants } from "../constants/RouteConstants";

export const OPEN_PROFILE_QUERY_PARAM = "openProfile";

export const buildPersonnelProfileUrl = (personnelId: number): string =>
    `${window.location.origin}${RouteConstants.ADMIN_PERSONNEL}?${OPEN_PROFILE_QUERY_PARAM}=${personnelId}`;
